export const toMapAsync = async (source, selector) => {
    const map = new Map();
    for (const value of source) {
        const key = await selector(value);
        const array = map.get(key);
        if (array === undefined) {
            map.set(key, [value]);
        }
        else {
            array.push(value);
        }
    }
    return map;
};
